const TIMEZONE_COUNTRY_CODE: Record<string, string> = {
  'Asia/Singapore': 'sg',
  'Asia/Kuala_Lumpur': 'my',
};

const countryCodeFromTimezone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return TIMEZONE_COUNTRY_CODE[timezone] || 'sg';
};

export default countryCodeFromTimezone;
